/**
 * Format a Beancount account name for user display.
 *
 * "Assets:Bank:Checking" → "Bank Checking"
 * "Expenses:Insurance:GeneralLiability" → "General Liability Insurance"
 * "Expenses:JobCosts:Materials" → "Job Materials"
 * "Equity:Owner-Draw" → "Owner Draw"
 */
export function formatAccountName(account: string): string {
  // Split on colons
  const parts = account.split(":");

  // Drop the top-level category (Assets, Expenses, Equity, Income, Liabilities)
  const meaningful = parts.length > 1 ? parts.slice(1) : parts;

  // Split camelCase/PascalCase and hyphens into words
  return meaningful
    .map((part) =>
      part
        .replace(/-/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2"),
    )
    .join(" ");
}

/**
 * An account as the client reads it: the server's label when the pick list
 * names one (words cell 3), else the derived name above. The clearing
 * account reads "Transfer between my accounts", never "Transfers Clearing".
 */
export function accountLabel(account: string, labels: Record<string, string>): string {
  return labels[account] ?? formatAccountName(account);
}

/** The clearing account a transfer between two of the client's accounts is booked to. */
export const CLEARING_ACCOUNT = "Assets:Transfers:Clearing";
